export enum OrderModalStep {
  OrderDetails = 'OrderDetails',
  InstrumentDetails = 'InstrumentDetails'
}
